<template>
	<div class="bg-color-white">
		<div class="fixed" :class="{'fixed-shadow': suspension}">
			<div class="main-header">
				<div class="main-header-width">
					<span><router-link tag="a" :to="{name: 'Home'}">{{headerName}}</router-link></span>
					<ul class="main-top-info">
						<li><router-link tag="a" :to="{name: 'Center'}">{{account}}</router-link></li>
						<li><router-link tag="a" :to="{name: 'Order'}"><i class="header-order-icon"></i>订单</router-link></li>
						<li>
							<router-link tag="a" :to="{name: 'Wallet'}"><i class="header-order-icon header-wallet-icon"></i>我的钱包</router-link>
						</li>
            <li>
              <router-link tag="a" :to="{name: 'DownloadList'}">
                <i class="header-order-icon header-download-icon"></i>下载列表
              </router-link>
            </li>
						<li style="border: 0;">
							<router-link tag="a" :to="{name: 'Document'}"><i class="header-order-icon header-document-icon"></i>功能文档</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="main-search">
				<div class="main-search-logo">
					<router-link tag="a" :to="{name: 'Home'}" :style="{ backgroundImage: 'url('+logoUrl+')'}"></router-link>
				</div>
				<div class="main-search-content">
					<ul class="manage_link">
						<li :class="{'active': isActive.one}">
							<router-link tag="a" :to="{name: 'Order'}">订单管理</router-link>
						</li>
						<li :class="{'active': isActive.two}">
							<router-link tag="a" :to="{name: 'Wallet'}">我的钱包</router-link>
						</li>
						<li :class="{'active': isActive.three}">
							<router-link tag="a" :to="{name: 'Center'}">个人中心</router-link>
						</li>
            <li :class="{'active': isActive.four}">
							<router-link tag="a" :to="{name: 'DownloadList'}">下载列表</router-link>
						</li>
					</ul>
					<div class="manage-search">
						<input type="text" placeholder="输入商品名称" v-model="keyword" />
						<div class="manage-search-btn">搜 索</div>
						<router-link tag="div" class="manage-search-btn" :to="{name: 'Category', query: { levelOne: '', levelTwo: '', levelThree: '', keyWord: keyword, selectType: selectType, brandId: '' }}">搜 索</router-link>
					</div>
				</div>
				<div class="main-spp-car manage-spp-car">
					<router-link tag="div" class="main-spp-car-shape" :to="{name: 'Shelves'}">
						我的货架
						<!-- <span v-bind:class="{'display-none': goodsCountShow}">{{goodsCount}}</span> -->
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapActions, mapState} from 'vuex'

	export default{
		data(){
			return {
	    		keyword: '', // 关键字
	    		selectType: 1,// 搜索类型
	    		suspension: false,
	    		isActive: {
	    			one: false,
	    			two: false,
            three: false,
            four: false,
          },
          headerName: this.$store.state.headerName,
          logoUrl: this.$store.state.logoUrl,
	    	}
		},
		watch: {
          // 如果路由有变化，会再次执行该方法
         	"$route": "routeChange"
        },
        created(){
        	this.routeChange();
        },
		computed: {
			...mapState([
                'goodsCount',
                'goodsCountShow',
                'account'
            ]),
		},
		mounted(){
			// this.setGoodsCount();
			window.addEventListener('scroll', this.handleScroll);
		},
		methods: {
			...mapActions({ setGoodsCount: 'setGoodsCount' }),
		    handleScroll: function(){
		    	var h = document.documentElement.scrollTop || document.body.scrollTop;
		    	if(h > 0){
	    			this.suspension = true;
	    		}else{
	    			this.suspension = false;
	    		}
		    },
		    routeChange(){
		    	var url = window.location.href;
				var strs = url.split("/");
				var str = strs[strs.length - 1];
				if(str == 'wallet'||str == 'receipt'){
					this.isActive.two = true;
					this.isActive.one  = false;
          this.isActive.three = false;
          this.isActive.four = false;
				}else if(str == 'center'){
					this.isActive.two = false;
					this.isActive.one  = false;
          this.isActive.three = true;
          this.isActive.four = false;
				}else if(str == 'order' || str == 'orderdetail'){
					this.isActive.two = false;
					this.isActive.one  = true;
          this.isActive.three = false;
          this.isActive.four = false;
        }
        else if(str == 'downloadlist'){
					this.isActive.two = false;
					this.isActive.one  = false;
          this.isActive.three = false;
          this.isActive.four = true;
				}
		    }
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// ManageHeader.vue?77f51cee